import { Button, Flex, Heading, Text } from '@chakra-ui/react';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { isFetchBaseQueryError } from 'rtkQuery/isFetchBaseQueryError';
import { isSharesproFetchQueryError } from 'rtkQuery/sharespro/isSharesproFetchQueryError';
import { isErrorWithMessage } from 'utils/isErrorWithMessage';

interface Props {
  title?: string;
  text?: string;
  error?: FetchBaseQueryError | SerializedError;
  onRetry?: () => void;
  headingSize?: string;
}

const ErrorContainer: FC<Props> = ({
  title,
  text,
  error,
  onRetry,
  headingSize = 'xl',
}) => {
  const { t } = useTranslation();

  let errorText;
  if (text) {
    errorText = text;
  } else if (error) {
    if (isSharesproFetchQueryError(error)) {
      const errorData = error.data as any;
      errorText = errorData.error_message;
    } else if (isErrorWithMessage(error)) {
      errorText = error.message;
    } else if (isFetchBaseQueryError(error) && error.status === 'FETCH_ERROR') {
      errorText = t('checkYourConnectionError');
    }
  }

  return (
    <Flex flexDirection="column" alignItems="center" maxWidth={720}>
      <Heading size={headingSize} mb={5} textAlign="center">
        {title ?? t('error')}
      </Heading>
      {errorText && (
        <Text mb={5} textAlign="center">
          {errorText}
        </Text>
      )}
      {onRetry && (
        <Button onClick={onRetry}>
          {t('tryAgain')}
        </Button>
      )}
    </Flex>
  );
};

export default ErrorContainer;
